<div class="container" style="text-align:center; color: darkorange;">
    <h1>Willkommen in {{ title }}</h1>
</div>
